import React from "react";
import Page from "../components/Page";

// Import
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { v4 as uuid } from "uuid";

// Import for Display
import Preloader from "../components/Preloader";
import RichText from "../components/RichText";
import ReviewSlider from "../components/ReviewSlider";
import NewsSlider from "../components/NewsSlider";
import cms from "../store/reducers/cms";

function IndexPage() {
  // Access our data so that we can display it
  const singleTypeSlug = "landing-page";
  const { data } = useSelector((state) => state.cms);
  const cmsData = data[singleTypeSlug] && data[singleTypeSlug].attributes;

  // Access our data and store it as collectionData
  const newsletterSlug = "newsletters";
  const newsletterData = data[newsletterSlug];

  const reviewSlug = "reviews";
  const reviewData = data[reviewSlug];

  // Only display the component if our data has been loaded
  if (!cmsData || !newsletterData || !reviewData) return <Preloader />;

  return (
    <Page data-wf-page="634efd6b20b65b7b93be44e5" data-wf-site="634efd6b20b65bfc05be44e4">
      <div
        className="sectionlanding wf-section"
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${cmsData.headerPhoto.data && cmsData.headerPhoto.data.attributes.url}`,
          backgroundPosition: "0px 0px, 0px 0px",
          backgroundSize: "auto, cover",
        }}
      >
        <div className="landingcontainer w-container">
          <div>
            <h1 className="textwhite textcenter">{cmsData.title}</h1>
          </div>
        </div>
      </div>

      {/* Newsletter Section */}
      <div className="section wf-section">
        <div className="container w-container">
          <div className="divnewsletter">
            <h2 className="textcenter">Latest News</h2>

            <NewsSlider data={newsletterData} autoplay={3000} />
          </div>
        </div>
      </div>
      <div className="section wf-section">
        <div className="container w-container">
          <div className="divhero">
            <div className="divherotext">
              <RichText text={cmsData.heroBody} />
            </div>
          </div>
          <div className="divhero flexvertical">
            <div className="divherotext">
              <RichText text={cmsData.heroBody2} />
              {/* Join Button */}
              <a href={cmsData.landingButton.slug} className="button w-button" target="_blank" rel="noreferrer">
                {cmsData.landingButton.text}
              </a>
            </div>
            {/* <a href="#" className="button w-button">
              JOIN
            </a> */}
          </div>
        </div>
      </div>

      {/* Panels */}
      <div className="section wf-section">
        <div className="containerpanel w-container">
          {cmsData.panels &&
            cmsData.panels.map((item) => {
              return (
                <Link to={item.slug} className="panel w-inline-block" key={uuid()}>
                  <img src={item.image.data && item.image.data.attributes.url} loading="lazy" alt={item.alt} className="panelimage" />
                  <div className="paneltext">
                    <div>{item.text}</div>
                  </div>
                </Link>
              );
            })}
        </div>
      </div>

      {/* Review Slider */}
      <div className="section fillwhite wf-section">
        <div className="container w-container">
          <ReviewSlider data={reviewData} autoplay={3000} />
        </div>
      </div>

      {/* Upcoming Events */}
      <div className="section wf-section">
        <div className="containercentered w-container">
          <h2 className="textcenter">Upcoming&nbsp;Events</h2>
          <div className="calendar w-embed w-iframe">
            <iframe title="calendar" src={cmsData.publicCalendar} style={{ border: "solid 1px #777" }} width="100%" height={500} frameBorder={0} scrolling="no" />
          </div>
        </div>
      </div>
    </Page>
  );
}

export default IndexPage;
